import { meta } from "./meta";
import type { ChromeSpiel } from "./types";

export const chrome: ChromeSpiel = {
  brandName: "DEVARM",
  homeAriaLabel: "DEVARM home",
  navLinks: [
    { label: "Work", href: "#work" },
    { label: "What we do", href: "#offerings" },
    { label: "Contact", href: "#contact" },
  ],
  ctaPrimary: "Start a conversation",
  ctaSecondary: "See the work",
  footerTagline: "Software development firm. Manila, Philippines.",
  email: "support@devarm.ph",
  devtoolsTaunt: "👀 Careful, this is where the bugs live.",
  devtoolsTauntStyle: "font-size: 20px; font-weight: bold;",
  devtoolsFreeze: "How may I help you",
  meta,
};
